import React, { Fragment } from 'react';
import './App.css';
import './style.css';


import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect
} from "react-router-dom";

import { ProgressSpinner } from 'primereact/progressspinner';
import QuizViewer from './quizViewer/QuizViewer';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';


class App extends React.Component {


  constructor() {

    super()

    console.log("start")

  }




  render = () => {


    return (

      <Fragment>

        <Router basename={process.env.PUBLIC_URL} >
          <Switch>
            <Route path="/">
              <QuizViewer app={this} selectedItem={null} callback={null} />
            </Route>
          </Switch>
        </Router>

        <div id="progressContainer" className="progress-container">
          <div className="background-container"></div>
          <div className="loading-container">
            <ProgressSpinner />
          </div>
        </div>
      </Fragment>
    )
  }
  showProgressContainer = () => {

    document.getElementById("progressContainer").style.display = "inline-block"
  }

  hideProgressContainer = () => {
    if (document.getElementById("progressContainer") != null)
      document.getElementById("progressContainer").style.display = "none"

  }



}

export default App;
